<template>
  <div v-if="order.orderAttributes.canAddPromoCode">
    <div class="input-with-button input-with-button--merge">
      <div class="input-with-button__input">
        <text-input
          v-model="code"
          type="text"
          label="Promo Code"
          name="code"
          @keydown.enter="apply"
        />
      </div>

      <div class="input-with-button__button">
        <button
          class="button button--secondary button--large normalcase"
          :class="{
            'button--loading': isApplyingDiscount
          }"
          type="button"
          :disabled="!code"
          @click="apply"
        >
          Redeem
        </button>
      </div>
    </div>
  </div>
</template>



<script>
  import events from '@/services/events';
  import errorHandlers from '@/services/error-handlers';
  import { mapGetters } from 'vuex';



  export default {
    name: 'ApplyDiscount',

    data() {
      return {
        code: null,
        isApplyingDiscount: false
      };
    },

    computed: {
      ...mapGetters('orders', ['order'])
    },

    methods: {
      async apply() {
        try {
          this.isApplyingDiscount = true;

          await this.$store.dispatch('orders/redeemOffer', {
            promotionCode: this.code
          });

          events.emit('notification', {
            type: 'success',
            message: `Promo code "${this.code}" was applied.`
          });

          this.code = null;
        }

        catch (error) {
          errorHandlers.generic(error);
        }

        finally {
          this.isApplyingDiscount = false;
        }
      }
    }
  };
</script>
